import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ISubscriptionApi } from "@/api/subscription";
import { SERVICES_TYPES, useInjection } from "@/ioc";

export const useOrganizationWallet = (organizationId: string) => {
  const subscriptionApi = useInjection<ISubscriptionApi>(SERVICES_TYPES.SUBSCRIPTION_API);

  return useQuery({
    queryKey: ["wallet", organizationId],
    queryFn: () => subscriptionApi.getOrganizationWallet(organizationId),
    enabled: !!organizationId
  });
};

export const useAdjustWallet = () => {
  const subscriptionApi = useInjection<ISubscriptionApi>(SERVICES_TYPES.SUBSCRIPTION_API);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ organizationId, amount }: { organizationId: string; amount: number }) =>
      subscriptionApi.adjustWalletBalance(organizationId, amount),
    onSuccess: (_, { organizationId }) => {
      queryClient.invalidateQueries({ queryKey: ["wallet", organizationId] });
    }
  });
};
